import { Choice } from "components/Choice";
import residencialImage from "assets/images/residencial.svg";
import comercialImage from "assets/images/comercial.svg";

import { useFormContext } from "components/Form";

import { useStepperContext } from "components/Steps";
import { useState } from "react";
import { DefaultFooter } from "components/DefaultFooter";

import * as S from "./styles";
import { MediaMatch } from "components/MediaMatch";

export function PropertyTypeForm() {
  const { goToNextStep } = useStepperContext();
  const {
    methodsForm: { setValue, getValues },
  } = useFormContext();

  const [propertyType, setPropertyType] = useState(() => {
    const intialValue = getValues("propertyType");

    return intialValue;
  });

  function handleSetPropertyType(propertyType: string) {
    setValue("propertyType", propertyType);
    setPropertyType(propertyType);
    goToNextStep();
  }

  return (
    <S.Container>
      <S.Title>
        Antes de começar, precisamos de algumas informações a respeito do imóvel
        que será dado como garantia.
        <br />
        Qual o tipo do imóvel?
      </S.Title>

      <S.WrapperChoices>
        <Choice
          title="Residencial"
          size="medium"
          onClick={() => handleSetPropertyType("Residencial")}
          isSelected={propertyType === "Residencial"}
          type="button"
        >
          <img src={residencialImage} alt="Uma Casa" />
        </Choice>

        <Choice
          title="Comercial"
          size="medium"
          onClick={() => handleSetPropertyType("Comercial")}
          isSelected={propertyType === "Comercial"}
          type="button"
        >
          <img src={comercialImage} alt="Uma loja" />
        </Choice>
      </S.WrapperChoices>

      <MediaMatch greaterThan="medium">
        <DefaultFooter />
      </MediaMatch>
    </S.Container>
  );
}
